// extracted by mini-css-extract-plugin
export var box = "_1i-2";
export var checkboxControl = "_1i-0";
export var checkboxRow = "_1i-a";
export var checked = "_1i-3";
export var descriptionSpacer = "_1i-c";
export var disabled = "_1i-4";
export var icon = "_1i-8";
export var input = "_1i-1";
export var labelSpacer = "_1i-b";
export var large = "_1i-7";
export var medium = "_1i-6";
export var small = "_1i-5";
export var text = "_1i-9";